import * as React from "react";
import { styled } from "@mui/material/styles";

import Card from "@mui/material/Card";
import Stack from "@mui/material/Stack";
import CardHeader from "@mui/material/CardHeader";
import Typography from "@mui/material/Typography";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
// import Accordion from "@mui/material/Accordion";
// import AccordionSummary from "@mui/material/AccordionSummary";
// import AccordionDetails from "@mui/material/AccordionDetails";

const Accordion = styled((props) => <MuiAccordion disableGutters {...props} />)(
  ({ theme }) => ({
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&::before": {
      display: "none",
    },
  })
);

const AccordionSummary = styled((props) => <MuiAccordionSummary {...props} />)(
  ({ theme }) => ({
    borderRadius: 8,
    backgroundColor: theme.palette.action.hover,
    // flexDirection: "row-reverse",
    // [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    //   {
    //     transform: "rotate(90deg)",
    //   },
    // [`& .${accordionSummaryClasses.content}`]: {
    //   marginLeft: theme.spacing(1),
    // },
    // ...theme.applyStyles("dark", {
    //   backgroundColor: "rgba(255, 255, 255, .05)",
    // }),
  })
);

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: 0,
}));

export default function AccordionExpandDefault({ data = [] }) {
  const [expanded, setExpanded] = React.useState();

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return data.map(({ title, value, unit, children }, i) => (
    <Accordion
      key={i}
      expanded={expanded === i}
      onChange={handleChange(i)}
      sx={{ bgcolor: "transparent" }}
    >
      <AccordionSummary
        sx={{ px: 1 }}
        id="panel1-header"
        aria-controls="panel1-content"
      >
        <Stack width="100%" direction="row" alignItems="center">
          <Typography
            pl={1}
            flexGrow={1}
            variant="caption"
            borderLeft="3px solid"
            color="text.secondary"
            borderColor="primary.main"
          >
            {title}
          </Typography>
          {typeof value === "string" ? (
            <Typography variant="subtitle2" fontSize={16}>
              {value}
            </Typography>
          ) : (
            value
          )}
          {unit && (
            <Typography
              width={40}
              fontSize={10}
              align="center"
              component="span"
              variant="caption"
              color="text.secondary"
            >
              {unit}
            </Typography>
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        {children && (
          <Stack pt={2} py={1} rowGap={1}>
            {children.map(({ title, value, unit }, i) => (
              <Card
                key={i}
                sx={{
                  borderRadius: 1,
                  boxShadow: "none",
                  bgcolor: "transparent",
                }}
              >
                <CardHeader
                  sx={{ p: 1 }}
                  title={
                    <Typography variant="caption" color="text.secondary">
                      {title}
                    </Typography>
                  }
                  action={
                    <Stack direction="row" alignItems="center">
                      <Typography variant="subtitle2" fontSize={14}>
                        {value}
                      </Typography>
                      {unit && (
                        <Typography
                          width={40}
                          fontSize={10}
                          align="center"
                          component="span"
                          variant="caption"
                          color="text.secondary"
                        >
                          {unit}
                        </Typography>
                      )}
                    </Stack>
                  }
                />
              </Card>
            ))}
          </Stack>
        )}
      </AccordionDetails>
    </Accordion>
  ));
}
